export default __webpack_public_path__ + "static/media/Knockout-93.50aeb51c.otf";